var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIncomingContractors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.72 11.9C22.31 10.3 21.01 9.08002 19.4 8.79002V7.77002H17.96V8.79002C16.34 9.08002 15.04 10.29 14.64 11.9H14.04V13.34H15.14C15.21 15.23 16.77 16.75 18.68 16.75C20.59 16.75 22.15 15.23 22.22 13.34H23.32V11.9H22.72ZM20.78 13.34C20.71 14.44 19.79 15.31 18.68 15.31C17.57 15.31 16.65 14.44 16.58 13.34H20.78ZM19.4 11.1V10.26C20.21 10.49 20.88 11.1 21.2 11.9H16.16C16.48 11.1 17.15 10.49 17.96 10.26V11.1H19.4Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.99H17.1C15.03 17.99 13.35 19.67 13.35 21.74V24H14.85V21.74C14.85 21.01 15.2 20.37 15.74 19.96V24H17.24V19.49H20.1V24H21.6V19.96C22.14 20.37 22.49 21.01 22.49 21.74V24H23.99V21.74C23.99 19.67 22.31 17.99 20.24 17.99H20.25Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3H16.5V1.5H15V3H9V1.5H7.5V3H4.5C3.68 3 3 3.68 3 4.5V19.5C3 20.32 3.68 21 4.5 21H11.85V19.5H4.5V9H13.5V7.5H4.5V4.5H7.5V6H9V4.5H15V6H16.5V4.5H19.5V6.35H21V4.5C21 3.68 20.33 3 19.5 3Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncomingContractors);
export default __webpack_public_path__ + "static/media/ic-incoming-contractors.ef8a635940c11dda170a94b0afab2e1f.svg";
export { ForwardRef as ReactComponent };